export const coreRouter = [
  {
    meta: {
      icon: 'iconfont iconxiaoshoushujuguanli',
      title: '微信账号管理',
      uri: '/newRetail/weChatRobot/accountManager',
    },
    component: () => import('./accountManager'),
    path: '/accountManager',
  },
  {
    meta: {
      icon: 'iconfont iconxiaoshoushujuguanli',
      title: '功能中心',
      uri: '/newRetail/weChatRobot/home',
    },
    component: () => import('./home'),
    path: '/functionCenter',
    hide: true,
  },
  {
    meta: {
      icon: 'iconfont iconxiaoshoushujuguanli',
      title: '入群欢迎',
      uri: '/newRetail/weChatRobot/welcomeInGroup',
    },
    component: () => import('./welcomeInGroup'),
    path: '/welcomeInGroup',
    hide: true,
    imgIconPath: require('@/assets/img/welcomeInGroup.png'),
  },
  {
    meta: {
      icon: 'iconfont iconxiaoshoushujuguanli',
      title: '广告踢人',
      uri: '/newRetail/weChatRobot/kickPeople',
    },
    component: () => import('./kickPeople'),
    path: '/kickPeople',
    hide: true,
    imgIconPath: require('@/assets/img/kickPeople.png'),
  },
  {
    meta: {
      icon: 'iconfont iconxiaoshoushujuguanli',
      title: '同意好友请求',
      uri: '/newRetail/weChatRobot/friendsInGroups',
    },
    component: () => import('./friendsInGroups'),
    path: '/friendsInGroups',
    hide: true,
    imgIconPath: require('@/assets/img/friendsInGroups.png'),
  },
  {
    meta: {
      icon: 'iconfont iconxiaoshoushujuguanli',
      title: '关键词回复',
      uri: '/newRetail/weChatRobot/keyWordsReply',
    },
    component: () => import('./keyWordsReply'),
    path: '/keyWordsReply',
    hide: true,
    imgIconPath: require('@/assets/img/keyWordsReply.png'),
  },
  {
    meta: {
      icon: 'iconfont iconxiaoshoushujuguanli',
      title: '关键词入群',
      uri: '/newRetail/weChatRobot/onlyGroup',
    },
    component: () => import('./onlyGroup'),
    path: '/onlyGroup',
    hide: true,
    imgIconPath: require('@/assets/img/onlyGroup.png'),
  },
  {
    meta: {
      icon: 'iconfont iconxiaoshoushujuguanli',
      title: '多群群发',
      uri: '/newRetail/weChatRobot/groupSending',
    },
    component: () => import('./groupSending'),
    path: '/groupSending',
    hide: true,
    imgIconPath: require('@/assets/img/groupSending.png'),
  },
  // {
  //   meta: {
  //     icon: 'iconfont iconxiaoshoushujuguanli',
  //     title: '定时群发任务',
  //     uri: '/weChatRobot/scheduledGroupTasks',
  //   },
  //   component: () => import('./scheduledGroupTasks'),
  //   path: '/scheduledGroupTasks',
  //   hide: true,
  //   imgIconPath: require('@/assets/img/scheduledGroupTasks.png'),
  // },
  // {
  //   meta: {
  //     icon: "iconfont iconxiaoshoushujuguanli",
  //     title: "被@后回复",
  //     uri: "/newRetail/weChatRobot/notificationReply",
  //   },
  //   component: () => import("./notificationReply"),
  //   path: "/notificationReply",
  //   hide: true,
  //   imgIconPath: require("@/assets/img/notificationReply.png"),
  // },
  // {
  //   meta: {
  //     icon: 'iconfont iconxiaoshoushujuguanli',
  //     title: '定时发送朋友圈',
  //     uri: '/weChatRobot/timingMessage',
  //   },
  //   component: () => import('./timingMessage'),
  //   path: '/timingMessage',
  //   hide: true,
  //  imgIconPath: require('@/assets/img/timingMessage.png'),
  // },
  // {
  //   meta: {
  //     icon: 'iconfont iconxiaoshoushujuguanli',
  //     title: '跟发朋友圈',
  //     uri: '/weChatRobot/followUpMessages',
  //   },
  //   component: () => import('./followUpMessages'),
  //   path: '/followUpMessages',
  //   hide: true,
  //   imgIconPath: require('@/assets/img/followUpMessages.png'),
  // },
  // {
  //   meta: {
  //     icon: 'iconfont iconxiaoshoushujuguanli',
  //     title: '清僵尸粉',
  //     uri: '/weChatRobot/cleaningFans',
  //   },
  //   component: () => import('./cleaningFans'),
  //   path: '/cleaningFans',
  //   hide: true,
  //  imgIconPath: require('@/assets/img/cleaningFans.png'),
  // },
  // {
  //   meta: {
  //     icon: 'iconfont iconxiaoshoushujuguanli',
  //     title: '检测屏蔽好友',
  //     uri: '/weChatRobot/checkScreen',
  //   },
  //   component: () => import('./checkScreen'),
  //   path: '/checkScreen',
  //   hide: true,
  //  imgIconPath: require('@/assets/img/checkScreen.png'),
  // },
  // {
  //   meta: {
  //     icon: 'iconfont iconxiaoshoushujuguanli',
  //     title: '自动订阅公众号',
  //     uri: '/weChatRobot/automaticSubscription',
  //   },
  //   component: () => import('./automaticSubscription'),
  //   path: '/automaticSubscription',
  //   hide: true,
  //  imgIconPath: require('@/assets/img/automaticSubscription.png'),
  // },
  {
    meta: {
      icon: 'iconfont iconxiaoshoushujuguanli',
      title: '批量修改群公告',
      uri: '/newRetail/weChatRobot/batchUpdateNotice',
    },
    component: () => import('./batchUpdateNotice'),
    path: '/batchUpdateNotice',
    hide: true,
    imgIconPath: require('@/assets/img/batchUpdateNotice.png'),
  },
  // {
  //   meta: {
  //     icon: 'iconfont iconxiaoshoushujuguanli',
  //     title: '群成员重复检查',
  //     uri: '/weChatRobot/memberInspection',
  //   },
  //   component: () => import('./memberInspection'),
  //   path: '/memberInspection',
  //   hide: true,
  //  imgIconPath: require('@/assets/img/memberInspection.png'),
  // },
  {
    meta: {
      icon: 'iconfont iconxiaoshoushujuguanli',
      title: '白名单',
      uri: '/newRetail/weChatRobot/whiteList',
    },
    component: () => import('./whiteList'),
    path: '/whiteList',
    hide: true,
    imgIconPath: require('@/assets/img/whiteList.png'),
  },
  {
    meta: {
      icon: 'iconfont iconxiaoshoushujuguanli',
      title: '黑名单',
      uri: '/newRetail/weChatRobot/blackList',
    },
    component: () => import('./blackList'),
    path: '/blackList',
    hide: true,
    imgIconPath: require('@/assets/img/blackList.png'),
  },
  {
    meta: {
      icon: 'iconfont iconxiaoshoushujuguanli',
      title: '关键词监控',
      uri: '/newRetail/weChatRobot/keywordMonitoring',
    },
    component: () => import('./keywordMonitoring'),
    path: '/keywordMonitoring',
    hide: true,
    imgIconPath: require('@/assets/img/keywordMonitoring.png'),
  },
  // {
  //   meta: {
  //     icon: 'iconfont iconxiaoshoushujuguanli',
  //     title: '批量拉人入群',
  //     uri: '/weChatRobot/batchPulling',
  //   },
  //   component: () => import('./batchPulling'),
  //   path: '/batchPulling',
  //   hide: true,
  //  imgIconPath: require('@/assets/img/batchPulling.png'),
  // },
  {
    meta: {
      icon: 'iconfont iconxiaoshoushujuguanli',
      title: '群组标签',
      uri: '/newRetail/weChatRobot/tabGrouping',
    },
    component: () => import('./tabGrouping'),
    path: '/tabGrouping',
    hide: true,
    imgIconPath: require('@/assets/img/tabGrouping.png'),
  },
  // {
  //   meta: {
  //     icon: 'iconfont iconxiaoshoushujuguanli',
  //     title: '机器人',
  //     uri: '/weChatRobot/robot',
  //   },
  //   component: () => import('./robot'),
  //   path: '/robot',
  //   hide: true,
  //  imgIconPath: require('@/assets/img/robot.png'),
  // },
  // {
  //   meta: {
  //     icon: 'iconfont iconxiaoshoushujuguanli',
  //     title: '数据统计',
  //     uri: '/weChatRobot/chartStatistics',
  //   },
  //   component: () => import('./chartStatistics'),
  //   path: '/chartStatistics',
  //   hide: true,
  //  imgIconPath: require('@/assets/img/chartStatistics.png'),
  // },
  {
    meta: {
      icon: 'iconfont iconxiaoshoushujuguanli',
      title: '素材管理',
      uri: '/newRetail/weChatRobot/material',
    },
    component: () => import('./material'),
    path: '/material',
  },
];
